import React, { useContext, useEffect, useState } from 'react';
import './Clasament.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import TopBar from '../../../topBar/TopBar';

import { useAuth } from '../../../../../AuthContext';

import fireIcon from '../../../../../imagesHome/fire.gif';

import { useNavigate } from 'react-router-dom';

import { PageNavContext } from '../../../FunctionalPageLogin';

import '../reglaredimensiune.css';

import crownLeader from './images/crown-leader.png';



const apiUrl = process.env.REACT_APP_API_URL;


/* =====================================================
   COUNTDOWN RESET SAPTAMANAL
===================================================== */

const getWeeklyResetCountdown = () => {

  const now = new Date();

  const nextReset = new Date(now);

  nextReset.setHours(0, 0, 0, 0);

  const dayOfWeek = now.getDay();

  const daysUntilNextMonday =
    ((8 - dayOfWeek) % 7) || 7;

  nextReset.setDate(
    now.getDate() + daysUntilNextMonday
  );

  const diffMs = Math.max(
    nextReset.getTime() - now.getTime(),
    0
  );

  const dayMs =
    24 * 60 * 60 * 1000;

  const hourMs =
    60 * 60 * 1000;

  const days =
    Math.floor(diffMs / dayMs);

  const hours =
    Math.floor(
      (diffMs % dayMs) / hourMs
    );

  return `${days}z ${hours}h`;
};


export default function Clasament() {

  const { user: loggedUser } = useAuth();

  const pageNav =
    useContext(PageNavContext);

  const navigate =
    useNavigate();


  /* =====================================================
     STATE
  ===================================================== */

  const [users, setUsers] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState('');

  const [
    timeUntilReset,
    setTimeUntilReset
  ] = useState(
    getWeeklyResetCountdown
  );

  const [tab, setTab] =
    useState('saptamanal');


  /* =====================================================
     USER LOGAT
  ===================================================== */

  const loggedUserId =
    Number(loggedUser?.user_id);


  const currentUserEntry =
    users.find((entry) => {

      const entryUserId =
        Number(entry?.user_id);

      return (
        Number.isFinite(loggedUserId) &&
        loggedUserId > 0 &&
        Number.isFinite(entryUserId) &&
        entryUserId === loggedUserId
      );

    });


  const currentUserRank =
    currentUserEntry
      ? Number(currentUserEntry.position) ||
        users.indexOf(currentUserEntry) + 1
      : null;


  const currentUserXp =
    currentUserEntry
      ? Number(currentUserEntry.points) || 0
      : 0;


  const currentUserIndex =
    currentUserEntry
      ? users.indexOf(currentUserEntry)
      : -1;


  const previousUserEntry =
    currentUserIndex > 0
      ? users[currentUserIndex - 1]
      : null;


  const previousUserRank =
    previousUserEntry
      ? Number(previousUserEntry.position) ||
        currentUserRank - 1
      : null;


  const previousUserXp =
    previousUserEntry
      ? Number(previousUserEntry.points) || 0
      : 0;


  const xpToPreviousRank =
    Math.max(
      previousUserXp - currentUserXp,
      0
    );


  const myRankProgressPercent =
    currentUserRank === 1
      ? 100
      : previousUserXp > 0
        ? Math.min(
            (
              currentUserXp /
              previousUserXp
            ) * 100,
            100
          )
        : 0;


  const hasZeroWeeklyXp =
    Boolean(currentUserEntry) &&
    currentUserXp === 0;


  /* =====================================================
     UTILIZATORI VIZIBILI
  ===================================================== */

  const visibleUsers =
    tab === 'prieteni'
      ? users
      : users.filter(
          (user) =>
            (Number(user?.points) || 0) > 0
        );


  /* =====================================================
     TOP 3
  ===================================================== */

  const topThreeUsers =
    visibleUsers
      .filter((user, index) => {

        const rank =
          Number(user.position) ||
          index + 1;

        return rank >= 1 && rank <= 3;

      })
      .sort((a, b) => {

        const rankA =
          Number(a.position) || 0;

        const rankB =
          Number(b.position) || 0;

        return rankA - rankB;

      });


  /* =====================================================
     RESTUL CLASAMENTULUI
  ===================================================== */

const remainingUsers =
  visibleUsers
    .filter((user, index) => {

      const rank =
        Number(user.position) ||
        index + 1;

      return rank > 3 && rank <= 6;

    })
    .sort((a, b) => {

      const rankA =
        Number(a.position) || 0;

      const rankB =
        Number(b.position) || 0;

      return rankA - rankB;

    });


  const getUserByRank = (rank) =>
    topThreeUsers.find(
      (user, index) =>
        (
          Number(user.position) ||
          index + 1
        ) === rank
    );


  /* =====================================================
     INCARCARE CLASAMENT
  ===================================================== */

  useEffect(() => {

    let isMounted = true;

    setLoading(true);


    const loadLeaderboard = async () => {

      try {

        const response =
          await fetch(
            `${apiUrl}/leaderboard?type=weekly`,
            {
              credentials: 'include',
            }
          );


        if (!response.ok) {
          throw new Error(
            'Nu am putut incarca clasamentul.'
          );
        }


        const data =
          await response.json();


        if (!isMounted) {
          return;
        }


        setUsers(
          Array.isArray(data)
            ? data
            : []
        );

        setError('');


      } catch (fetchError) {

        if (!isMounted) {
          return;
        }


        console.error(
          'Eroare leaderboard:',
          fetchError
        );


        setError(
          'Clasamentul nu poate fi afisat momentan.'
        );

        setUsers([]);


      } finally {

        if (isMounted) {
          setLoading(false);
        }

      }

    };


    loadLeaderboard();


    return () => {
      isMounted = false;
    };

  }, [tab]);


  /* =====================================================
     COUNTDOWN
  ===================================================== */

  useEffect(() => {

    const refreshCountdown = () => {
      setTimeUntilReset(
        getWeeklyResetCountdown()
      );
    };


    refreshCountdown();


    const intervalId =
      setInterval(
        refreshCountdown,
        60 * 1000
      );


    return () => {
      clearInterval(intervalId);
    };

  }, []);


  /* =====================================================
     RETURN
  ===================================================== */

  return (

    <div className="componentsmenu-container-main">

      <div className="componentsmenu-left-blank" />

      <div className="componentsmenu-container">

        <TopBar />


<div className="leaderboard-page-heading">

  <div className="leaderboard-page-heading-left">

 

    <div>
      <div className="leaderboard-page-heading-title">
        Clasament
      </div>

     
    </div>

  </div>


  {tab === 'saptamanal' && (

    <div className="leaderboard-page-timer">

      <div className="leaderboard-page-timer-clock">
        ◷
      </div>

      <div>
      

        <div className="leaderboard-page-timer-value">
          {timeUntilReset}
        </div>
      </div>

    </div>

  )}

</div>

        {/* =====================================================
            POZITIA USERULUI
        ===================================================== */}

        {tab === 'saptamanal' && (

          <div
            className="leaderboard-my-rank-hero"
            role="status"
            aria-live="polite"
          >

            {loading ? (

              <>

                <div className="leaderboard-my-rank-head">

                  <div className="leaderboard-my-rank-title">
                    Pozitia ta se calculeaza...
                  </div>

                  <div className="leaderboard-my-rank-xp">
                    -- XP
                  </div>

                </div>


                <div className="leaderboard-my-rank-subtitle">
                  Asteapta un moment pentru clasamentul actualizat.
                </div>


             

              </>

            ) : hasZeroWeeklyXp ? (

              <>

                <div className="leaderboard-my-rank-head">

                  <div className="leaderboard-my-rank-title">
                    Nu ai XP saptamanal inca
                  </div>

                  <div className="leaderboard-my-rank-xp">
                    0 XP
                  </div>

                </div>


                <div className="leaderboard-my-rank-subtitle">
                  Fa o lectie ca sa intri in clasament.
                </div>


                <button
                  type="button"
                  className="leaderboard-start-lessons-btn"
                  onClick={() => {

                    if (pageNav) {

                      pageNav('Invata');

                      return;
                    }


                    navigate(
                      '/functionalpagelogin'
                    );

                  }}
                >
                  Mergi la lectii
                </button>

              </>

            ) : currentUserRank ? (

          <>
  <div className="leaderboard-my-rank-main">

    <div className="leaderboard-my-rank-position">
      #{currentUserRank}
    </div>

    <div className="leaderboard-my-rank-avatar">
      {currentUserEntry?.profile_picture ? (
        <img
          src={currentUserEntry.profile_picture}
          alt={currentUserEntry.username || 'Utilizator'}
        />
      ) : (
        <FontAwesomeIcon
          icon={faUser}
          className="leaderboard-my-rank-user-icon"
        />
      )}
    </div>

    <div className="leaderboard-my-rank-info">
      <div className="leaderboard-my-rank-name">
        {currentUserEntry?.username || 'Utilizator'}
        {currentUserRank === 1}
      </div>

      <div className="leaderboard-my-rank-status">
        {currentUserRank === 1
          ? 'Esti pe primul loc!'
          : `Mai ai ${xpToPreviousRank} XP pana la locul #${previousUserRank}`
        }
      </div>
    </div>

    <div className="leaderboard-my-rank-xp">
      {currentUserXp} XP
    </div>

  </div>

 
</>

            ) : (

              <>

                <div className="leaderboard-my-rank-head">

                  <div className="leaderboard-my-rank-title">
                    Pozitia ta nu este in clasament
                  </div>

                  <div className="leaderboard-my-rank-xp">
                    0 XP
                  </div>

                </div>


                <div className="leaderboard-my-rank-subtitle">
                  Continua sa castigi XP pentru a urca in top.
                </div>


             

              </>

            )}

          </div>

        )}


        {/* =====================================================
            CLASAMENT
        ===================================================== */}

        <div className="leaderboard-list">


      
<div className="leaderboard-scroll-area">
      


            {/* LOADING */}

            {loading && (

              <div className="leaderboard-message leaderboard-feedback">

                {tab === 'prieteni'
                  ? 'Se incarca clasamentul prietenilor...'
                  : 'Se incarca clasamentul saptamanal...'
                }

              </div>

            )}


            {/* ERROR */}

            {!loading && error && (

              <div className="leaderboard-message leaderboard-feedback">
                {error}
              </div>

            )}


            {/* EMPTY */}

            {!loading &&
              !error &&
              tab === 'saptamanal' &&
              visibleUsers.length === 0 && (

                <div className="leaderboard-message leaderboard-feedback">
                  Nu exista inca utilizatori cu XP saptamanal.
                </div>

              )}


            {/* =====================================================
                PODIUM TOP 3
            ===================================================== */}

            {!loading &&
              !error &&
              topThreeUsers.length > 0 && (

                <div className="leaderboard-podium">

                  {[2, 1, 3].map((rank) => {

                    const user =
                      getUserByRank(rank);


                    if (!user) {

                      return (

                        <div
                          key={rank}
                          className={`
                            leaderboard-podium-place
                            podium-${rank}
                            podium-empty
                          `}
                        />

                      );

                    }


                    const entryUserId =
                      Number(user?.user_id);


                    const isLoggedUser =
                      Number.isFinite(loggedUserId) &&
                      loggedUserId > 0 &&
                      Number.isFinite(entryUserId) &&
                      entryUserId === loggedUserId;


                    return (

                      <div
                        key={
                          user.user_id ||
                          `${user.username}-${rank}`
                        }
                        className={`
                          leaderboard-podium-place
                          podium-${rank}
                          ${
                            isLoggedUser
                              ? 'podium-logged-user'
                              : ''
                          }
                        `}
                      >


                        {/* COROANA */}

                


                        {/* AVATAR */}

                  {/* AVATAR */}

<div className="leaderboard-podium-avatar-wrap">

  {rank === 1 && (
    <img
      src={crownLeader}
      alt="Coroana locul 1"
      className="leaderboard-podium-crown-img"
    />
  )}

  <div className="leaderboard-podium-avatar">

    {user.profile_picture ? (

      <img
        src={user.profile_picture}
        alt={user.username || 'Utilizator'}
      />

    ) : (

      <FontAwesomeIcon
        icon={faUser}
        className="leaderboard-podium-user-icon"
      />

    )}

  </div>

  <div className="leaderboard-podium-rank">
    {rank}
  </div>

</div>


{/* CARD */}

<div className="leaderboard-podium-card">

<div className="leaderboard-podium-divider" />

  <div className="leaderboard-podium-name">
    {user.username || 'Utilizator'}
  </div>

  

  <div className="leaderboard-podium-xp">
    {Number(user.points) || 0} XP
  </div>

</div>


                  

                      </div>

                    );

                  })}

                </div>

              )}



            {/* =====================================================
                SEPARATOR
            ===================================================== */}

            {!loading &&
              !error &&
              remainingUsers.length > 0 && (

                <div className="leaderboard-after-podium">
                  Clasamentul complet
                </div>

              )}


            {/* =====================================================
                LOCURILE 4+
            ===================================================== */}

            {!loading &&
              !error &&
              remainingUsers.map(
                (user, index) => {

                  const rank =
                    Number(user.position) ||
                    index + 4;


                  const entryUserId =
                    Number(user?.user_id);


                  const isLoggedUser =
                    Number.isFinite(loggedUserId) &&
                    loggedUserId > 0 &&
                    Number.isFinite(entryUserId) &&
                    entryUserId === loggedUserId;


                  return (

                    <div
                      key={
                        user.user_id ||
                        `${user.username}-${index}`
                      }
                      className={`
                        leaderboard-user
                        current
                        other-rank
                        ${
                          isLoggedUser
                            ? 'logged-user-row'
                            : ''
                        }
                      `}
                      style={{
                        marginBottom:
                          index ===
                          remainingUsers.length - 1
                            ? 0
                            : undefined,
                      }}
                    >

                      {/* RANK */}

                      <div className="leaderboard-rank-wrap">

                        <span className="leaderboard-rank">
                          #{rank}
                        </span>

                      </div>


                      {/* AVATAR */}

                      <div className="leaderboard-avatar current">

                        {user.profile_picture ? (

                          <img
                            src={user.profile_picture}
                            alt={
                              user.username ||
                              'Utilizator'
                            }
                            className="leaderboard-avatar-image"
                          />

                        ) : (

                          <FontAwesomeIcon
                            icon={faUser}
                            className="leaderboard-usericon"
                          />

                        )}

                      </div>


                      {/* NUME */}

                      <div className="leaderboard-name current">

                        {user.username ||
                          'Utilizator'}

                      </div>


                      {/* XP */}

                      <div className="leaderboard-xp current">

                        {Number(user.points) || 0} XP

                      </div>

                    </div>

                  );

                }
              )}

              {!loading && !error && visibleUsers.length > 0 && (
  <button
    type="button"
    className="leaderboard-see-all"
  onClick={() => {
  if (pageNav) {
    pageNav('FullLeaderboard');
  }
}}
  >
    <div className="leaderboard-see-all-icon">
      <FontAwesomeIcon icon={faUser} />
    </div>

    <div className="leaderboard-see-all-content">
      <div className="leaderboard-see-all-title">
        Vezi tot clasamentul
      </div>

      <div className="leaderboard-see-all-subtitle">
        Descopera toti utilizatorii activi saptamana aceasta
      </div>
    </div>

    <div className="leaderboard-see-all-arrow">
      ›
    </div>
  </button>
)}


          </div>

        </div>

      </div>

    </div>

  );
}